<template>
  <div>
    <b-row>
      <b-col lg="3">
        <b-form-group
          label="Table QR Code Design"
          label-class="dine-in-table-creation-section-labels py-0"
        >
          <small class="sub-section-labels"
            >Change how your QR codes look to better match your brand!</small
          >
        </b-form-group>
      </b-col>
      <b-col lg="5"
        ><b-form-group>
          <div class="d-flex align-items-center justify-content-between">
            <span class="dine-in-table-creation-labels">Customize QR Code</span>
            <switches
              v-model="form.is_qr_code_design_enable"
              theme="custom"
              color="primary"
              type-bold="true"
              style="top: 0"
              class="ml-3 mb-0"
              :emit-on-mount="false"
              id="qrCustomized"
              text-enabled="ON"
              text-disabled="OFF"
            />
          </div>
        </b-form-group>
        <template v-if="form.is_qr_code_design_enable">
          <b-form-group
            label="Header"
            label-class="dine-in-table-creation-labels"
          >
            <b-form-input
              id="qrHeader"
              v-model="form.qr_header"
              :maxlength="maxLengths.qr_header"
            >
            </b-form-input>
            <b-form-invalid-feedback
              :force-show="formValidatedState('qr_header')"
            >
              <div
                class="text-danger"
                v-for="(error, errorIndex) of getErrorMessage('qr_header')"
                :key="`error-qr-header-${errorIndex}`"
              >
                {{ error.$message }}
              </div>
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            label="Footer"
            label-class="dine-in-table-creation-labels"
          >
            <b-form-textarea
              name="footer"
              id="qrFooter"
              class="form-control"
              :rows="3"
              :maxlength="maxLengths.qr_instructions"
              v-model="form.qr_instructions"
            >
            </b-form-textarea>
            <div class="d-flex justify-content-between">
              <b-form-invalid-feedback
                :force-show="formValidatedState('qr_instructions')"
              >
                <div
                  class="text-danger"
                  v-for="(error, errorIndex) of getErrorMessage(
                    'qr_instructions'
                  )"
                  :key="`error-qr-description-${errorIndex}`"
                >
                  {{ error.$message }}
                </div>
              </b-form-invalid-feedback>
              <small
                :class="[
                  'flex-shrink-0 counter-container mt-1 text-right',
                  { 'w-100': !formValidatedState('qr_instructions') },
                ]"
              >
                {{ qrFooterCount }} / {{ maxLengths.qr_instructions }}
              </small>
            </div>
          </b-form-group>
          <b-col md="12" class="px-0">
            <b-row>
              <b-col md="4">
                <b-form-group
                  label="Table QR Code Color"
                  label-class="dine-in-table-creation-labels"
                >
                  <div class="d-flex align-items-start w-100">
                    <div class="mr-2 flex-grow-1">
                      <b-form-input
                        type="color"
                        v-model="form.qr_tint_color"
                        id="qrColor"
                      ></b-form-input>
                      <small class="text-muted">{{ form.qr_tint_color }}</small>
                    </div>
                    <img
                      src="@/assets/images/icons/colorpicker.svg"
                      alt="Color Picker Icon"
                      class="mt-2"
                    />
                  </div>
                </b-form-group>
              </b-col>
              <col md="1" />
              <b-col md="4">
                <b-form-group
                  label="Background Color"
                  label-class="dine-in-table-creation-labels"
                >
                  <div class="d-flex align-items-start w-100">
                    <div class="mr-2 flex-grow-1">
                      <b-form-input
                        type="color"
                        v-model="form.qr_background_color"
                        id="qrBackgroundColor"
                      ></b-form-input>
                      <small class="text-muted">{{
                        form.qr_background_color
                      }}</small>
                    </div>
                    <img
                      src="@/assets/images/icons/colorpicker.svg"
                      alt="Color Picker Icon"
                      class="mt-2"
                    />
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group
                  label="Text Color"
                  label-class="dine-in-table-creation-labels"
                >
                  <b-form-radio-group
                    id="qrtextColor"
                    v-model="form.qr_text_color"
                    name="text-color"
                  >
                    <b-form-radio value="#000000" class="mb-2">
                      <span
                        class="py-1 px-2 rounded"
                        :style="{
                          'background-color': '#ffffff',
                        }"
                      >
                        Aa
                      </span>
                    </b-form-radio>
                    <b-form-radio value="#FFFFFF">
                      <span
                        class="py-1 px-2 rounded text-white"
                        :style="{
                          'background-color': '#000000',
                        }"
                      >
                        Aa
                      </span>
                    </b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </template>
        <b-form-group
          label="Table QR Code Preview"
          label-class="dine-in-table-creation-labels"
        >
          <div
            id="qrCodePreviewContainer"
            class="border rounded qr-design-container d-flex align-items-center justify-content-center p-5"
            :style="{
              'background-color': !form.is_qr_code_design_enable
                ? '#FFFFFF'
                : form.qr_background_color,
            }"
          >
            <div
              class="d-flex flex-column align-items-center justify-content-center"
            >
              <div
                class="qr-header text-center"
                v-if="form.is_qr_code_design_enable"
                :style="{ color: form.qr_text_color }"
              >
                {{ form.qr_header }}
              </div>
              <div class="qr-code-icon border bg-white rounded mt-3 p-3">
                <QRCodeFillable
                  :fillColor="
                    !form.is_qr_code_design_enable
                      ? '#000000'
                      : form.qr_tint_color
                  "
                />
              </div>
              <div
                class="qr_table_no text-center mt-1 mb-3"
                :style="{
                  color: form.is_qr_code_design_enable
                    ? form.qr_text_color
                    : null,
                }"
              >
                Table-000
              </div>
              <div
                :class="['qr-description text-center mx-auto', qrFooterWidth]"
                v-if="form.is_qr_code_design_enable"
                :style="{ color: form.qr_text_color }"
              >
                {{ form.qr_instructions }}
              </div>
            </div>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
  watch,
} from "@vue/composition-api";
import Switches from "vue-switches";
import { useVuelidate } from "@vuelidate/core";
import { maxLength, helpers, requiredIf } from "@vuelidate/validators";
import QRCodeFillable from "@/components/common/QRCodeFillable.vue";
import _ from "lodash";

export default defineComponent({
  components: { Switches, QRCodeFillable },
  setup(props, { root, emit }) {
    const apiErrors = computed(
      () => root.$store.state.storeDineIn.errors || {}
    );
    const tableData = computed(() => root.$store.state.storeDineIn.tableData);

    const maxLengths = {
      qr_header: 50,
      qr_instructions: 500,
    };

    const qrHeaderFooterPlaceholder = {
      header: "Dine-in with us!",
      footer:
        "Scan this QR code with your phone camera to start placing orders",
    };

    const form = ref({
      is_qr_code_design_enable: false,
      qr_header: qrHeaderFooterPlaceholder.header,
      qr_instructions: qrHeaderFooterPlaceholder.footer,
      qr_tint_color: "#000000",
      qr_background_color: "#ffffff",
      qr_text_color: "#000000",
    });

    const qrFooterCount = computed(() =>
      form.value.qr_instructions ? form.value.qr_instructions.length : 0
    );

    const alphanumericAndSomeSpecialCharacters =
      /^[A-Za-z0-9!';$".,&:*@?/#<([\-+=>)\]\s”’]*$/;

    const rules = {
      qr_header: {
        required: helpers.withMessage(
          "Header is required.",
          requiredIf(() => form.value.is_qr_code_design_enable)
        ),
        maxLength: helpers.withMessage(
          `Header may only contain ${maxLengths.qr_header} characters.`,
          maxLength(maxLengths.qr_header)
        ),
        mustBeAlphanumericAndSomeSpecialCharacters: helpers.withMessage(
          "Header may only contain alphanumeric and some special characters.",
          (qr_header) =>
            !helpers.req(qr_header) ||
            alphanumericAndSomeSpecialCharacters.test(qr_header)
        ),
      },
      qr_instructions: {
        required: helpers.withMessage(
          "Footer is required.",
          requiredIf(() => form.value.is_qr_code_design_enable)
        ),
        maxLength: helpers.withMessage(
          `Description may only contain ${maxLengths.qr_instructions} characters.`,
          maxLength(maxLengths.qr_instructions)
        ),
        mustBeAlphanumericAndSomeSpecialCharacters: helpers.withMessage(
          "Description may only contain alphanumeric and some special characters.",
          (qr_instructions) =>
            !helpers.req(qr_instructions) ||
            alphanumericAndSomeSpecialCharacters.test(qr_instructions)
        ),
      },
    };

    const v$ = useVuelidate(rules, form);

    const formValidatedState = (field) => {
      return !!apiErrors.value[field] || v$.value[field].$error;
    };

    const getErrorMessage = (field) => {
      if (
        !_.isEmpty(apiErrors.value) &&
        _.has(apiErrors.value, field) &&
        apiErrors.value[field]
      ) {
        return [
          {
            $message: apiErrors.value[field],
          },
        ];
      } else {
        return v$.value[field].$errors;
      }
    };

    const qrPreviewContainerWidth = ref(0);

    const qrFooterWidth = computed(() => {
      return qrPreviewContainerWidth.value > 350 ? "w-50" : "w-100";
    });

    const getQrPreviewContainerWidth = () => {
      setTimeout(() => {
        qrPreviewContainerWidth.value = document.getElementById(
          "qrCodePreviewContainer"
        ).clientWidth;
      }, 300);
    };

    addEventListener("resize", () => {
      getQrPreviewContainerWidth();
    });

    getQrPreviewContainerWidth();

    const setFormData = () => {
      const {
        is_qr_code_design_enable,
        qr_header,
        qr_instructions,
        qr_tint_color,
        qr_background_color,
        qr_text_color,
      } = tableData.value;
      form.value = {
        is_qr_code_design_enable: is_qr_code_design_enable,
        qr_header: qr_header || qrHeaderFooterPlaceholder.header,
        qr_instructions: qr_instructions || qrHeaderFooterPlaceholder.footer,
        qr_tint_color: qr_tint_color || form.value.qr_tint_color,
        qr_background_color:
          qr_background_color || form.value.qr_background_color,
        qr_text_color: qr_text_color || form.value.qr_text_color,
      };
      setUntouchedForm();
    };

    const setUntouchedForm = () => {
      emit("setUntouchedForm", {
        qrCode: JSON.stringify(form.value),
      });
    };

    onMounted(() => {
      root.$on("validateTableCreation", () => v$.value.$touch());
      if (tableData.value) setFormData();
      else setUntouchedForm();
    });

    onBeforeUnmount(() => {
      root.$off("validateTableCreation");
    });

    watch(
      () => tableData.value,
      () => {
        if (tableData.value) setFormData();
      }
    );

    watch(
      () => form.value.is_qr_code_design_enable,
      () => {
        v$.value.$reset();
      }
    );

    return {
      apiErrors,
      maxLengths,
      qrFooterCount,
      qrFooterWidth,
      qrHeaderFooterPlaceholder,
      form,
      v$,
      formValidatedState,
      getErrorMessage,
      tableData,
    };
  },
});
</script>

<style lang="scss" scoped>
.qr-design-container {
  min-height: 350px;
  .qr-code-icon {
    width: 170px;
    height: 170px;
    svg {
      object-fit: cover;
    }
  }
  .qr-header {
    font-family: MainFontBold, sans-serif;
    font-size: 1.15em;
  }
  .qr-footer {
    word-break: break-word;
  }
  .qr_table_no {
    font-family: MainFontBold, sans-serif;
  }
}
</style>
